const generateOnlyFilter = (params) => {
  const { tab } = params;
  const onlyFilterValues = {
    orders: 'order',
    sales: 'sale',
  };
  return onlyFilterValues[tab];
};

export default generateOnlyFilter;
